import { messages } from '@/shared/constants/messages';
import type { Id, ProjectStatus } from '@/shared/types/domain';

/**
 * "aprovado por você" · "ajustes solicitados por Pr. Marcos" (decisão 28).
 *
 * A ESCOLHA da frase é lógica e mora aqui, não em `messages.ts` — mesma
 * divisão de `attributionFor`: o arquivo de textos guarda templates, a feature
 * guarda o `switch`.
 *
 * `switch` exaustivo e **sem `default`**: se um status novo entrar em
 * `HISTORY_STATUSES` sem frase, o build quebra em vez de a linha sair muda.
 * Os quatro que não são decisão de análise nunca chegam aqui — a consulta os
 * filtra —, e mesmo assim têm ramo, porque o tipo é o enum inteiro.
 */
export function historyLine(
  status: ProjectStatus,
  actorProfileId: Id | null,
  actorName: string,
  currentProfileId: Id | undefined,
): string {
  // "por você" em vez do próprio nome: quem varre a lista está procurando o
  // que os OUTROS decidiram, e o próprio nome repetido dez vezes atrapalha
  // exatamente essa varredura.
  const who =
    actorProfileId !== null && actorProfileId === currentProfileId
      ? messages.review.historyByYou
      : actorName;

  switch (status) {
    case 'approved':
      return messages.review.historyApproved(who);
    case 'changes_requested':
      return messages.review.historyChangesRequested(who);
    case 'rejected':
      return messages.review.historyRejected(who);
    case 'cancelled':
      return messages.review.historyCancelled(who);

    case 'draft':
    case 'under_review':
    case 'completed':
      return messages.review.historyDecided(who);
  }
}
